import { Redirect, router } from 'expo-router';
import { useEffect } from 'react';

import { useAuth } from '@/contexts/authContext';
import { useInfoModal } from '@/contexts/infoModalContext';
import { i18n } from '@/utils/i18n';

const BrowseOnly = () => {
  const { showInfo } = useInfoModal();
  const { state } = useAuth();

  //Locales
  const registerTitle = i18n.t('register_modal.title');
  const registerSubtitle = i18n.t('register_modal.subtitle');
  const registerButtonLabel = i18n.t('register_modal.button_label');

  useEffect(() => {
    if (state.user?.user?.role !== 'INDIVIDUAL' && state.user?.user?.role !== 'NON_PROFIT_ORG')
      showInfo({
        type: 'full',
        title: registerTitle,
        subtitle: registerSubtitle,
        buttonLabel: registerButtonLabel,
        showClose: false,
        closeOnTapOutside: false,
        onButtonPress: () => {
          router.navigate('/');
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state.user?.user?.role === 'INDIVIDUAL' || state.user?.user?.role === 'NON_PROFIT_ORG')
    return <Redirect href={'/unauthorized'} />;

  return null;
};

export default BrowseOnly;
